import axiosInstance from "./axiosInstance";
import { BASE_URL } from "../constants/applicationConfig";

const BASE_URL_USER = `${BASE_URL}/api/email`;

export class EmailApi {
  static async verifyEmail(verifyRequest) {
    return await axiosInstance.post(
      `${BASE_URL_USER}/verification`,
      verifyRequest,
    );
  }

  static async resendVerificationEmail(resendRequest) {
    return await axiosInstance.post(
      `${BASE_URL_USER}/re-verification`,
      resendRequest,
    );
  }
}
